import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import LoadingView from "../components/state-handlers/LoadingView";
import { FC, PropsWithChildren, useMemo } from "react";
import { useLocation } from "react-router-dom";

/**
 * Sentinel mounted only while unauthenticated — `withAuthenticationRequired` redirects before this renders meaningfully.
 */
const AuthPlaceholder: FC = () => null;

export const AuthenticationGuard: FC<PropsWithChildren> = ({ children }) => {
  const { isLoading, isAuthenticated } = useAuth0();
  const location = useLocation();

  const returnToFullPath = `${location.pathname}${location.search}${location.hash}`;

  const GuardedRoute = useMemo(() => {
    return withAuthenticationRequired(AuthPlaceholder, {
      /** Passed to Auth0 `appState` — `<Navigate state>` never runs because the HOC issues `loginWithRedirect` first. */
      returnTo: returnToFullPath,
      onRedirecting: () => <LoadingView />,
    });
  }, [returnToFullPath]);

  if (isLoading) return <LoadingView />;
  if (!isAuthenticated) {
    return <GuardedRoute />;
  }

  return <>{children}</>;
};
